import {writePrecursorXMLSingle} from "../writes/udo";
import {write} from "../utilities/Utility";
import svc from 'svc';



export const types = {
	SET_DEFAULT: 'USER/SET_DEFAULT',
	SET_ATTRIBUTE_BY_OBJ: 'USER/SET_ATTRIBUTE_BY_OBJ'
}

const defaultState = {
	type: 'user',
	firstName: '',
	lastName: '',
	userName: '',
	dispatchUserType: 'Dispatch',
	active: 'Y',
	keyName: null,
	loading: false,
	reloadTable: false,
	update: null,
	rowIndex: null,
	newUser: false,
	password: null,
	expandedRowIds: []
}

export default (state = defaultState, action) => {
	switch (action.type) {
		case types.SET_DEFAULT:
			return defaultState;
		case types.SET_ATTRIBUTE_BY_OBJ:
			console.log(action.obj);
			return Object.assign({}, state, action.obj)
		default:
			return state;
	}
}

export const actions = {
	setDefault: () => {
		return {type: types.SET_DEFAULT};
	},
	setAttributeByObj: (obj) => {
		return {type: types.SET_ATTRIBUTE_BY_OBJ, obj}
	},
	saveUser: () => {
		return (dispatch, getState) => {
			dispatch(actions.setAttributeByObj(loadingObj(true)));
			const currentUserState = getState().user;
			const writeObj = Object.assign({}, currentUserState, {
				key: currentUserState.keyName
			})
			const precursor = writePrecursorXMLSingle(writeObj);
			write(precursor).then((res) => {
				let keyName = currentUserState.keyName
				let update = 'changeRow';
				let promise = Promise.resolve({payload: null});
				if (keyName === null) {
					update = 'addRow';
					keyName = res.Data.Results[0].Key;
					promise = svc.send('resetPassword', {key: keyName})
				}
				promise.then((res) => {
					const password = res.payload;
					const changeObj = {
						loading: false,
						update,
						keyName,
						password
					}
					dispatch(actions.setAttributeByObj(changeObj));
				});
			})
		}
	},
	resetPassword: () => {
		return (dispatch, getState) => {
			dispatch(actions.setAttributeByObj(loadingObj(true)));
			const key = getState().user.keyName;
			const promise = svc.send('resetPassword', {key});
			promise.then((res) => {
				const password = res.payload;
				const changeObj = {
					loading: false,
					password
				}
				dispatch(actions.setAttributeByObj(changeObj));
			});
		}
	}
}

function loadingObj(bool) {
	return {
		loading: bool
	}
}


// WEBPACK FOOTER //
// ./src/redux/user.js